import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth';
import alerts from './modules/alerts-module';
import profile from './modules/profile-module';
import users from './modules/users-module';
import roles from './modules/roles-module';
import categories from './modules/categories-module';
import tags from './modules/tags-module';
import items from './modules/items-module';

// TODO: these modules should live in their respective components, not globally.
import selection from './modules/selection-module';
import marketSelection from './modules/market-selection-module';
import vestimateSelection from './modules/vestimate-selection-module';
import companySelection from './modules/company-selection-module';

import dashboard from './modules/dashboard-module';
import user from './modules/user-module';
import findCompanies from './modules/find-companies';
import companyList from './modules/company-list-module';
import companyProfile from './modules/company-profile-module';
import errorHandler from './modules/error-handler-module';
import genericModal from './modules/generic-modal-module';
import favorite from './modules/favorite-module';
import notification from './modules/notification-module';
import myData from './modules/my-data-module';
import year from './modules/year-module';
import ifRelease from './modules/if-release-module';
import imrRelease from './modules/imr-release-module';
import companyReport from './modules/company-report-module';
import subscriptions from './modules/subscriptions-module';
import team from './modules/team-module';
import companyListNoAction from './modules/company-list-no-action-module';
import prospectSearch from './modules/prospect-search-module';
import cart from './modules/cart-module';
import checkout from './modules/checkout-module';
import multiples from './modules/multiples-module';
import sample from './modules/sample-module';
import entryProducts from './modules/entry-products-module';
import selectedReportModule from './modules/selected-report-module';
import invoicesModule from './modules/invoices-module';
import pdf from './modules/pdf-module';
import tracking from './modules/tracking-module';

Vue.use(Vuex);
Vue.config.devtools = true;

export default new Vuex.Store({
  modules: {
    auth,
    alerts,
    profile,
    users,
    roles,
    categories,
    tags,
    items,
    selection,
    marketSelection,
    vestimateSelection,
    companySelection,
    user,
    dashboard,
    findCompanies,
    companyList,
    companyProfile,
    errorHandler,
    genericModal,
    favorite,
    notification,
    myData,
    year,
    ifRelease,
    imrRelease,
    companyReport,
    subscriptions,
    team,
    companyListNoAction,
    prospectSearch,
    cart,
    checkout,
    multiples,
    sample,
    entryProducts,
    selectedReportModule,
    invoicesModule,
    pdf,
    tracking
  },
});
